<footer class="footer-area" style="    padding-top: 83px;">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12" style="text-align: center;">
                <div class="row">
                    <img style="    max-width: 188px;" src="./../../../assets/logo.png" alt="Lama Driving School">
                </div>
                <div class="row" style="    text-align: left;
                margin-top: 24px;">
                    <h6 style="color: white;">{{footer}}</h6>
                    <br>
                    <br>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12" style="text-align: left;">

                <div class="single-footer-widget mb-30">
                    <h3> NAVIGATION

                    </h3>
                    <ul class="support-link">
                        <li><a routerLink="/"> Home </a></li>
                        <li><a routerLink="/courses">Courses </a></li>
                        <li><a routerLink="/packages">Packages </a></li>
                        <li><a routerLink="/contact">Contact </a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-2 col-sm-12 " style="text-align: left;">
                <div class="single-footer-widget mb-30">
                    <h3> USEFUL LINKS</h3>
                    <ul class="support-link">
                        <li><a routerLink="/about"> About Us </a></li>
                        <li><a routerLink="/terms-and-conditions"> Terms and Conditions</a></li>
                        <li><a routerLink="/privacy-policy"> Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12" style="text-align: left;">
                <div class="single-footer-widget mb-30">
                    <h3> CALL US
                    </h3>
                    <ul class="support-link">
                        <li>
                            <a [href]="'tel:' + phone">Phone:<br>{{phone}}</a><br>
                            <a *ngIf="phone2" [href]="'tel:' + phone2">{{phone2}}</a><br>
                            <a *ngIf="phone3" [href]="'tel:' + phone3">{{phone3}}</a>
                        </li>

                        <!-- <li><a routerLink="/support">   Staten Island:
                            <br>
                            718 727 7070<br>
                            718 727 7277 </a></li> -->
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12" style="text-align: center;">
                <div class="single-footer-widget mb-30">
                    <h6 style="color: white;"> Stay Connected</h6>
                    <ul class="social-link">
                        <li *ngIf="faceBook"><a (click)="openSocalMediaNewWindow(faceBook)" class="d-block" target="_blank"><i
                                    class='bx bxl-facebook'></i></a></li>
                        <li *ngIf="instagram"><a (click)="openSocalMediaNewWindow(instagram)" class="d-block" target="_blank"><i
                                    class='bx bxl-instagram'></i></a></li>
                        <li *ngIf="linkedin"><a (click)="openSocalMediaNewWindow(linkedin)" class="d-block" target="_blank"><i
                                    class='bx bxl-linkedin'></i></a></li>
                        <li *ngIf="youtube"><a (click)="openSocalMediaNewWindow(youtube)" class="d-block" target="_blank"><i
                                    class='bx bxl-youtube'></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom-area">
        <div class="container">
            <p style="color: white !important">© Lama Driving School {{dateYear}} </p>
        </div>
    </div>
</footer>